var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasPerms(_vm.perms)),expression:"hasPerms(perms)"}],attrs:{"size":_vm.size,"type":_vm.type,"loading":_vm.loading,"plain":_vm.plain,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }